import React from 'react';

import isEmpty from 'lodash/isEmpty';

import DoneIcon from '@atlaskit/icon/glyph/editor/done';

import { Button } from '@qality/common-components/src/atoms/Button';

import {
  ListBannerButtonContainer,
  ListBannerContainer,
  ListBannerContentContainer,
  ListBannerImage,
  ListBannerList,
  ListBannerListItem,
  ListBannerListItemTitle,
  ListBannerTextContainer,
  ListBannerTitle,
} from './ListBanner.styled';

export interface BannerAction {
  text: string;
  callback: () => void;
}

interface ListBannerViewProps {
  title: string;
  items: Array<string>;
  primaryAction: BannerAction;
  secondaryAction: BannerAction;
  bannerImagePath?: string;
}

export const ListBannerView: React.FC<ListBannerViewProps> = ({
  title,
  items,
  primaryAction,
  secondaryAction,
  bannerImagePath,
}: ListBannerViewProps) => {
  return (
    <ListBannerContainer>
      <ListBannerContentContainer>
        <ListBannerTextContainer>
          <ListBannerTitle>{title}</ListBannerTitle>
          {!isEmpty(items) && (
            <ListBannerList>
              {items.map((item, index) => (
                <ListBannerListItem key={`list-gadget-item-${index}`}>
                  <DoneIcon label={null} />
                  <ListBannerListItemTitle>{item}</ListBannerListItemTitle>
                </ListBannerListItem>
              ))}
            </ListBannerList>
          )}
        </ListBannerTextContainer>
        {bannerImagePath && <ListBannerImage src={bannerImagePath} alt='' />}
      </ListBannerContentContainer>
      <ListBannerButtonContainer>
        <Button appearance='primary' onClick={primaryAction.callback}>
          {primaryAction.text}
        </Button>
        <Button appearance='subtle-link' onClick={secondaryAction.callback}>
          {secondaryAction.text}
        </Button>
      </ListBannerButtonContainer>
    </ListBannerContainer>
  );
};
